import { withTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "@mui/material";
import Button from "@mui/material/Button";
import { useNitroCAStore } from "../store/CompetitiveAnalysisStore";

const StyledButton = withTheme(
  styled(Button)(
    ({ selected, theme }: { selected: boolean; theme: Theme }) => ({
      padding: 10,
      borderRadius: 8,
      borderColor: selected ? "" : "#666",

      backgroundColor: selected ? theme.palette.secondary.main : "white",
      color: selected ? theme.palette.secondary.contrastText : "#666",
      opacity: selected ? 1 : 0.8,
      "&:hover": {
        borderColor: "#666",
        opacity: 1,
        backgroundColor: selected ? theme.palette.secondary.main : "white",
      },
    })
  )
);

const PickerOption = ({
  label,
  Icon,
  select,
  selected,
  width,
  height,
  isMobile,
}: {
  label: string;
  Icon?: any;
  select: () => void;
  selected: boolean;
  width?: string | number;
  height?: string | number;
  isMobile?: boolean;
}) => {
  const [setDisplayFreightDetailsPanel] = useNitroCAStore((state) => [
    state.setDisplayRailFreightDetailsPanel,
  ]);
  return (
    <StyledButton
      selected={selected}
      variant="outlined"
      style={{
        width,
        height,
      }}
      onClick={() => {
        setDisplayFreightDetailsPanel(false);
        select();
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        {Icon && (
          <Icon size={isMobile ? 18 : 20} color={selected ? "white" : "#666"} />
        )}
        <div
          style={{
            fontSize: isMobile ? 13 : 14,
          }}
        >
          {label}
        </div>
      </div>
    </StyledButton>
  );
};

export default PickerOption;
